import * as PIXI from 'pixi.js';
import { IArea, SpriteType } from 'types/map';

const spriteMap: { [key: string]: PIXI.Sprite } = {};
const selectionSpriteMap: { [key: string]: PIXI.Sprite } = {};
const mainDestinationMap: { [key: string]: PIXI.Sprite } = {};
const mainDestinationSelectionMap: { [key: string]: PIXI.Sprite } = {};

const mapsByType = {
  'available': spriteMap,
  'selection': selectionSpriteMap,
  'main-destination': mainDestinationMap,
  'main-destination-selection': mainDestinationSelectionMap,
};

const GlobalSpriteMap = {
  put: async (areaKey: string, whatKind: SpriteType, sprite: PIXI.Sprite) => {
    // Scale the sprite (not sure why it's necessary)
    sprite.scale.set(0.5, 0.5);
    // Add it to the cache
    mapsByType[whatKind][areaKey] = sprite;
  },

  get: async (area: IArea, whatKind: SpriteType) => {
    const { areaKey: key } = area;

    const mapToUse = mapsByType[whatKind];

    if (mapToUse[key]) {
      return mapToUse[key];
    }
  }
};

export default GlobalSpriteMap;

